/* esm.sh - applesauce-core@5.2.0/dist/helpers/lru */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/lru.mjs";
